module.exports = __webpack_public_path__ + "static/media/map-pin.4f87e369.svg";